import React from 'react';
import { TextFieldForm } from 'web-library';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';
import { ContactNumberFormItem } from '../../../../components/form-items/ContactNumberFormItem';
import { useStyles } from './styles';
import {
  CandidateProfileFormData,
  CandidateProfileFormDefaultValues,
  CandidateProfileIsDisableInputs,
} from '../../../../models';
import FormHeader from '../../../../components/form-items/FormHeader';
import ToggleDisplayEditFormItem from '../../../../components/ToggleDisplayEditFormItem';
import { getIExamMasterCodeSelected } from '../../logic/useCandidateProfileForm';

export interface AdminProfileContactDetailsProps {
  isEditState: boolean;
  formHook: UseFormReturn<CandidateProfileFormData>;
  isDisableInputs?: CandidateProfileIsDisableInputs;
  isHideExtraFormInfo?: boolean;
  formDefaultValues?: CandidateProfileFormDefaultValues;
  isProfileUploading?: boolean;
}

const AdminProfileContactDetails = ({
  isEditState,
  formHook,
  isDisableInputs = undefined,
  isHideExtraFormInfo = false,
  formDefaultValues = undefined,
  isProfileUploading = false,
}: AdminProfileContactDetailsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { formState:{errors} } = formHook;

  return (
    <>
      <FormHeader
        title={t('admin->>CreateOpsAdminForm.Contact Details')}
        containerClassName={classes.formHeader}
      />

      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        containerClassName={classes.formElementContainer}
        labelText={t('admin->>CreateOpsAdminForm.Email')}
        id="inputText-candidateProfile-email"
        valueText={formDefaultValues?.email}
        EditComponent={
          <TextFieldForm
            id="inputText-candidateProfile-email"
            form={formHook}
            label={t('admin->>CreateOpsAdminForm.Email')}
            name="email"
            type="text"
            error={!!errors.email}
            helperText={errors?.email?.message?.toString()}
            fullWidth
            inputProps={{ disabled: isDisableInputs?.email || isProfileUploading }}
          />
        }
      />

      <ToggleDisplayEditFormItem
        id="adminProfileMobile"
        isEditState={isEditState}
        labelText={t('admin->>CreateOpsAdminForm.Mobile No')}
        valueText={`${formDefaultValues?.mobileCountryCode?.codeValueDescription ?? '-'} ${
          formDefaultValues?.mobileContactNumber ?? '-'
        }`}
        containerClassName={classes.formElementContainer}
        EditComponent={
          <ContactNumberFormItem
            id="adminProfileMobile"
            formHook={formHook}
            countryCodeDefaultValue={formDefaultValues?.mobileCountryCode}
            numberDefaultValue={formDefaultValues?.mobileContactNumber}
            label={t('admin->>CreateOpsAdminForm.Mobile No')}
            countryCodeisOptionEqualToValue={getIExamMasterCodeSelected}
            countryCode={{
              name: 'mobileCountryCode',
              error: !!errors.mobileCountryCode,
              helperText: errors?.mobileCountryCode?.message?.toString(),
              disabled: isDisableInputs?.mobileCountryCode || isProfileUploading,
            }}
            number={{
              name: 'mobileContactNumber',
              error: !!errors.mobileContactNumber,
              helperText: errors?.mobileContactNumber?.message?.toString(),
              disabled: isDisableInputs?.mobileContactNumber || isProfileUploading,
            }}
            isSkipTransform
            isRequired
          />
        }
      />
    </>
  );
};

export default AdminProfileContactDetails;
